import { render, staticRenderFns } from "./grantNamedRegionsCards.vue?vue&type=template&id=05fdbe65&scoped=true&"
import script from "./grantNamedRegionsCards.vue?vue&type=script&lang=js&"
export * from "./grantNamedRegionsCards.vue?vue&type=script&lang=js&"
import style0 from "./grantNamedRegionsCards.vue?vue&type=style&index=0&id=05fdbe65&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05fdbe65",
  null
  
)

export default component.exports